import React from 'react'
import style from './style.module.scss'
import trophyLocation from '@assets/images/wpl/WPLTitle.svg'
import MyImage from '@shared/components/myImage'
import chessLocation from '@assets/images/chess/location.svg'

function WPLHeader() {
  return (
    <header className={style.chessHeader}>
      <div className={style.info}>
        <div className={style.teamAndPlayers}>
          <div className="d-flex flex-column align-items-center">
            <h2>5</h2>
            <p>Teams</p>
          </div>
          <div className="d-flex flex-column align-items-center">
            <h2>91</h2>
            <p>Players</p>
          </div>
        </div>
        <div className={`${style.teamAndPlayers} justify-content-center`}>
          <div className="d-flex flex-column align-items-center">
            <h2>22</h2>
            <p>Matches</p>
          </div>
        </div>
      </div>
      <div className={style.mainTitle}>
        <div className="d-flex gap-4 align-items-center">
          <div className="d-flex flex-column justify-content-start align-items-start gap-4">
            <MyImage src={trophyLocation} alt="Trophy Location" />
          </div>
        </div>
        <div className={style.location}>
          <MyImage src={chessLocation} alt="Chess Location" />
          India
        </div>
      </div>
      <div className={`${style.date} d-md-flex d-none`}>
        <p>14 Feb - 15 Mar 2025</p>
      </div>
      <div className={`d-md-none d-flex mt-4 ${style.mwebInfo}`}>
        <div>
          <h2>5</h2>
          <p>Teams</p>
        </div>
        <div>
          <h2>91</h2>
          <p>Players</p>
        </div>
        <div>
          <h2>22</h2>
          <p>Matches</p>
        </div>
      </div>
      <div className={`${style.date} d-md-none mt-4`}>
        <p>14 Feb - 15 Mar 2025</p>
      </div>
    </header>
  )
}

export default WPLHeader
